import PropTypes from 'prop-types'
import { Table, Form, InputGroup, Button } from 'react-bootstrap'
import { useState, useMemo, useEffect } from 'react'

// Formatear monto con separadores de miles
const formatMonto = monto => {
    if (!monto && monto !== 0) return ''
    return new Intl.NumberFormat('es-CL', {
        style: 'currency',
        currency: 'CLP',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    }).format(monto)
}


const BonosRutaTable = ({ bonos = [] }) => {
    const [search, setSearch] = useState('')
    const [page, setPage] = useState(1)
    const pageSize = 10

    // Filtrar por Extra o Tipo
    const filteredBonos = useMemo(() => {
        if (!search) return bonos
        return bonos.filter(b =>
            (b.extra && b.extra.toLowerCase().includes(search.toLowerCase())) ||
            (b.tipo_extra && b.tipo_extra.toLowerCase().includes(search.toLowerCase()))
        )
    }, [bonos, search])

    // Paginación
    const totalPages = Math.ceil((filteredBonos?.length || 0) / pageSize) || 1
    const pagedBonos = useMemo(() => {
        const start = (page - 1) * pageSize
        return filteredBonos.slice(start, start + pageSize)
    }, [filteredBonos, page])

    // Reset page if search or bonos change
    useEffect(() => {
        setPage(1)
    }, [search, bonos])

    return (
        <div>
            <InputGroup className="mb-2" size="sm" style={{ maxWidth: 300 }}>
                <Form.Control
                    placeholder="Buscar por Extra o Tipo..."
                    value={search}
                    onChange={e => setSearch(e.target.value)}
                />
                {search && (
                    <Button variant="outline-secondary" size="sm" onClick={() => setSearch('')}>
                        Limpiar
                    </Button>
                )}
            </InputGroup>
            <div style={{ maxHeight: 320, overflowY: 'auto', overflowX: 'auto' }}>
                <Table striped bordered hover size="sm" style={{ minWidth: '600px', marginBottom: 0 }}>
                    <thead>
                        <tr>
                            <th>Extra</th>
                            <th>Tipo</th>
                            <th>Monto</th>
                            <th>Estado</th>
                        </tr>
                    </thead>
                    <tbody>
                        {pagedBonos && pagedBonos.length > 0 ? (
                            pagedBonos.map(bono => (
                                <tr key={bono.id}>
                                    <td>{bono.extra}</td>
                                    <td>{bono.tipo_extra}</td>
                                    <td>
                                        <span style={{
                                            fontWeight: 'bold',
                                            color: bono.tipo_extra === 'bonos' ? '#198754' : '#dc3545'
                                        }}>
                                            {formatMonto(bono.monto)}
                                        </span>
                                    </td>
                                    <td>{bono.estado}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={4} className="text-center">
                                    No hay bonos para esta ruta
                                </td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </div>
            {/* Paginación */}
            <div className="d-flex justify-content-between align-items-center mt-2" style={{ maxWidth: 400 }}>
                <Button variant="outline-primary" size="sm" onClick={() => setPage(1)} disabled={page === 1}>
                    {'<<'}
                </Button>
                <Button
                    variant="outline-primary"
                    size="sm"
                    onClick={() => setPage(p => Math.max(1, p - 1))}
                    disabled={page === 1}>
                    {'<'}
                </Button>
                <span style={{ minWidth: 80, textAlign: 'center' }}>
                    Página <strong>{page}</strong> de <strong>{totalPages}</strong>
                </span>
                <Button
                    variant="outline-primary"
                    size="sm"
                    onClick={() => setPage(p => Math.min(totalPages, p + 1))}
                    disabled={page === totalPages}>
                    {'>'}
                </Button>
                <Button
                    variant="outline-primary"
                    size="sm"
                    onClick={() => setPage(totalPages)}
                    disabled={page === totalPages}>
                    {'>>'}
                </Button>
                <span style={{ minWidth: 80, textAlign: 'center' }}>
                    Total de bonos: <strong>{filteredBonos.length}</strong>
                </span>
            </div>
        </div>
    )
}

BonosRutaTable.propTypes = {
    bonos: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number.isRequired,
            extra: PropTypes.string,
            tipo_extra: PropTypes.string,
            monto: PropTypes.number,
            estado: PropTypes.string
        })
    )
}

export default BonosRutaTable